






































































































import { debounceProcess } from "@/helpers/debounce";
import { ResponsePagination } from "@/models/constant/interface/common.interface";
import { DATE_TIME_HOURS_DEFAULT_FORMAT } from "@/models/constants/date.constant";
import { Messages } from "@/models/enums/messages.enum";
import {
  DataListAssetBook,
  DataResponseListHistoryDepre,
  RequestAssetClosePeriod,
  ResponseClosePeriod,
} from "@/models/interface/assets.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { assetsServices } from "@/services/assets.service";
import moment from "moment";
import Vue from "vue";
export default Vue.extend({
  data() {
    this.getListAssetBook = debounceProcess(this.getListAssetBook, 200);
    return {
      dataListBook: [] as DataListAssetBook[],
      dataCalendar: {} as ResponseClosePeriod,
      closePeriodCheckBox: false as boolean,
      loading: false as boolean,
      loadingListAssetBook: false as boolean,
      form: this.$form.createForm(this, { name: "depresiasiClosePeriod" }),
      formRules: {
        book: {
          label: "lbl_book",
          name: "book",
          placeholder: "lbl_type_to_find_placeholder",
          decorator: [
            "book",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        period: {
          label: "lbl_period",
          name: "period",
          placeholder: "lbl_period_placeholder",
          decorator: [
            "period",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
      columnsTable: [
        {
          title: this.$t("lbl_asset_book"),
          dataIndex: "assetBook",
          key: "assetBook",
          width: 110,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_depreciate_by"),
          dataIndex: "depreciateBy",
          key: "depreciateBy",
          width: 110,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_start_depre"),
          dataIndex: "startDepre",
          key: "startDepre",
          width: 110,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_end_depre"),
          dataIndex: "endDepre",
          key: "endDepre",
          width: 110,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_done"),
          dataIndex: "done",
          key: "done",
          width: 110,
          scopedSlots: { customRender: "isEnable" },
        },
      ],
      dataSource: [] as DataResponseListHistoryDepre[],
      totalData: 0,
      limit: 10,
      page: 1,
      loadingTable: false,
      disabledButton: false as boolean,
    };
  },
  methods: {
    responsePageSizeChange(response: ResponsePagination): void {
      this.limit = response.size;
      this.page = 1;
      this.getHistoryDepre();
    },
    responseCurrentPageChange(response: ResponsePagination): void {
      this.page = response.page;
      this.getHistoryDepre();
    },
    checkDepre() {
      assetsServices.checkAssetDepre().then(response => {
        this.disabledButton = response;
      });
    },
    getHistoryDepre() {
      const params: RequestQueryParamsModel = {
        limit: this.limit,
        page: this.page - 1,
        sorts: "startDepre:desc",
      };
      this.loadingTable = true;
      assetsServices
        .listHistoryDepre(params)
        .then(response => {
          this.totalData = response.totalElements;
          this.dataSource = response.data.map(dataMap => {
            return {
              ...dataMap,
              startDepre: dataMap.startDepre
                ? moment(dataMap.startDepre).format(
                    DATE_TIME_HOURS_DEFAULT_FORMAT
                  )
                : "-",
              endDepre: dataMap.endDepre
                ? moment(dataMap.endDepre).format(
                    DATE_TIME_HOURS_DEFAULT_FORMAT
                  )
                : "-",
            };
          });
        })
        .finally(() => (this.loadingTable = false));
    },
    handleCancel() {
      this.form.resetFields();
      this.$router.go(-1);
    },
    getListAssetBook(valueSearch) {
      let params = {
        page: 0,
        limit: 10,
        search: `active~true`,
      } as RequestQueryParamsModel;
      if (valueSearch) params.search += `_AND_name~*${valueSearch}*`;
      this.loadingListAssetBook = true;
      assetsServices
        .listAssetBook(params)
        .then(data => {
          this.dataListBook = data.data;
        })
        .finally(() => (this.loadingListAssetBook = false));
    },
    getListCalendarClosePeriod() {
      let params = {
        modul: "Asset",
      } as RequestQueryParamsModel;
      assetsServices.listCalendarClosePeriodByModul(params).then(data => {
        this.form.setFieldsValue({
          period: data.calendar.month,
        });
        // this.dataCalendar = data
      });
    },
    submitForm() {
      this.form.validateFields((err, res) => {
        if (err) return;
        const payload = {
          assetBook: res.book,
          assetBookDescription: this.dataListBook.find(
            dataFind => dataFind.id === res.book
          )?.name,
          // period: res.period,
          // closePeriod: this.closePeriodCheckBox
        } as RequestAssetClosePeriod;
        this.loading = true;
        assetsServices
          .updateAssetClosePeriod(payload)
          .then(() => {
            this.$notification.success({
              description: Messages.UPDATE_SUCCESS,
              message: "Success",
              duration: 30,
            });
            this.checkDepre();
            this.getHistoryDepre();
          })
          .catch(() =>
            this.$notification.error({
              description: Messages.UPDATE_FAIL,
              message: "Error",
              duration: 30,
            })
          )
          .finally(() => (this.loading = false));
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].componentOptions.children[1].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  created() {
    this.getListAssetBook("");
    this.getListCalendarClosePeriod();
    this.getHistoryDepre();
    this.checkDepre();
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      };
    },
  },
});
